export const CREATE_VOUCHER = 'CREATE_VOUCHER'
export const UPDATE_VOUCHER = 'UPDATE_VOUCHER'
export const DELETE_VOUCHER = 'DELETE_VOUCHER'